export default __webpack_public_path__ + "static/WorkshopPoster-e8fa612978a64c5b8da2aa0fe0da10b5.jpg";